module.exports = __webpack_public_path__ + "static/img/1079.f6c79c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1079.jpg
// module id = 261
// module chunks = 0